import React from 'react';
import '@/spark/src/styles/index.css';
import '@/app/styles/scrollbar.css';
import { createRoot } from 'react-dom/client';

import App from '@/app/AppRoutes';

// Entry for `public/index-fullstory.html` (`build-prod-fullstory`, what
// production serves).  It renders the same `App` as `src/app/main.jsx`, so
// a route can no longer exist in one entry and be missing from the other.

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(<App />);
